import { Message, ThreadedMessageType, MessageThread } from "@salaxy/core";

import { ListControllerBase, ListControllerBaseBindings } from "../bases";

import { UiHelpers } from "../../services";

class WorkerExpenseReportControllerBindings extends ListControllerBaseBindings {
  /** Type of the timesheet. Options are hourlyReport and timeReport */
  public reportType =  "<";
  /**
   * CRUD controller that typically defines the values for url template and
   */
  public crudController =  "<";
}

/** Controller handles expense usecases*/
export class WorkerExpenseReportController extends ListControllerBase<MessageThread, Message> {
  /** Bindings for components that use this controller */
  public static bindings = new WorkerExpenseReportControllerBindings();

  /** Type of the timesheet. Options are hourlyReport and timeReport */
  public reportType: "expense" | "travel";

  /**
   * For NG-dependency injection
   * @ignore
   */
   public static $inject = ["UiHelpers"];

   private _rowTypes = ["expenses", "milageDaily", "milageOther", "milageOwnCar", "dailyAllowance"];

   /** Constructor for dependency injection */
   constructor(
     uiHelpers: UiHelpers
   ) {
     super(uiHelpers);
   }

   /** Template for edit UI that is shown in a modal dialog. */
   public getEditDialogTemplateUrl(): string {
    throw new Error("Method not implemented.");
  }

  /**
   * Creating of a new item
   */
  public getBlank(): Message {
    throw new Error("Method not implemented.");
  }

  /**
   * List of items
   */
  public get list(): Message[] {
    if (!this.parent) {
      return null;
    }
    return this.parent.messages;
  }

  /**
   * Ensure that atleast one message exists
   */
   public getCalcRowMessage() {
    const messageIndex = this.list.findIndex(x => x.type === ThreadedMessageType.CalcRow);
    if (messageIndex >= 0) {
      return this.list[messageIndex];
    }

    this.list.unshift({type: ThreadedMessageType.CalcRow, contentData: {rows: []}});
    return this.list[0];
  }

  /**
   * Get rowTypes based on report type
   */
  public getRowTypes() {
    // TODO: implement dirrerent row types
    if (this.reportType === "expense") {
      return this._rowTypes;
    }
    if (this.reportType === "travel") {
      return this._rowTypes;
    }
  }


}
